import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

/**
 * @param orgId
 */
class TaxService {
  /**
   *
   * @param payload
   * @return {Promise<*>}
   */
  createTax = async (payload) => {
    const createdTax = await Helpers.post({
      url: Constants.TAXES,
      data: payload,
    });
    return createdTax;
  };

  /**
   * @param orgId
   * @param page
   * @param limit
   * @param isActive
   * @param taxName
   * @param gstName
   * @return {Promise<*>}
   */
  getTaxes = async (orgId, page, limit, isActive, isTaxGroup) => {
    let url = `${Constants.TAXES}?`;
    if (orgId) url += `org_id=${orgId}&`;
    if (page) url += `page=${page}&`;
    if (limit) url += `limit=${limit}&`;
    if (isActive) url += `is_active=${isActive}&`;
    if (isTaxGroup) url += `is_group=${isTaxGroup}&`;
    const taxes = await Helpers.get({ url });
    return taxes;
  };

  /**
   * @param payload
   * @return {Promise<*>}
   */
  updateTax = async (payload) => {
    const updatedTax = await Helpers.put({
      url: Constants.TAXES,
      data: payload,
    });
    return updatedTax;
  };

  /**
   * @param orgId
   * @param page
   * @param limit
   * @param isActive
   * @return {Promise<*>}
   */
     getTaxTypes = async (orgId, page, limit, isActive) => {
       let url = `${Constants.TAXES}/tax_type?`;
       if (orgId) url += `org_id=${orgId}&`;
       if (page) url += `page=${page}&`;
       if (limit) url += `limit=${limit}&`;
       if (isActive) url += `is_active=${isActive}&`;
       const taxTypes = await Helpers.get({ url });
       return taxTypes;
     };
}
export default new TaxService();
